export const TableContainer: CSSFunction = ({ theme }) => ({
    padding: '8px',
    fontSize: '12px',
    fontFamily: theme.fonts.tvFont,
    width: '100%',
  });

export const HeaderCell: CSSFunction = ({ theme }) => ({
    color: theme.colors.text[2],
    fontSize: '12px',
  });

export const Table: CSSFunction = () => ({
    width: '100%',
  });

export const TableCell: CSSFunction = ({ theme }) => ({
    fontSize: '14px',
    color: theme.colors.text[1],
  });

export const ScripNameContainer: CSSFunction = () => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '14px',
});

export const SegmentName: CSSFunction = ({ theme }) => ({
  fontFamily: theme.fonts.tvFont,
  fontSize: '12px',
  color: theme.colors.text[2],
});

export const AlertPrice: CSSFunction = ({ theme }) => ({
  fontFamily: theme.fonts.tvFont,
  fontSize: '14px',
  color: theme.colors.text[2],
  lineHeight: '1.7',
});

export const AlertPriceContainer: CSSFunction = () => ({
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'column',
  gap: '2px',
});

export const ActionContainer: CSSFunction = () => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
});

export const ActionButton: CSSFunction = () => ({
  padding: '0px',
  display: 'flex',
  alignItems: 'center',
});

export const TableRow: CSSFunction = () => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: '10px',
});

export const TableBody: CSSFunction = () => ({
  overflowY: 'auto',
  maxHeight: '200px',
  display: 'block',
});
